import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
import EmptyState from '../../components/EmptyState';

export default function PortalArticleDetail() {
  const { slug } = useParams<{ slug: string }>();

  const { data: article, isLoading } = useQuery({
    queryKey: ['kb-article', slug],
    queryFn: async () => {
      const res = await apiClient.get(`/kb/${slug}`);
      return res.data.data?.article ?? res.data.data;
    },
    enabled: !!slug,
  });

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4 pb-10">
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-row-odd rounded w-64" />
          <div className="h-60 bg-row-odd rounded" />
        </div>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="flex flex-col gap-4 pb-10">
        <div className="card">
          <EmptyState>Article not found.</EmptyState>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 pb-10">
      <article className="card" style={{ padding: '2rem' }}>
        <h1 className="text-2xl font-bold text-fg mb-2">{article.title}</h1>
        <div className="flex items-center gap-3 text-sm text-muted mb-6">
          {article.category && <span>{article.category}</span>}
          <span>{new Date(article.createdAt).toLocaleDateString()}</span>
        </div>
        <div className="text-sm text-fg whitespace-pre-wrap leading-relaxed">
          {article.content}
        </div>
      </article>

      <div className="flex items-center justify-center gap-6">
        <p className="text-sm text-muted">Was this article helpful?</p>
        <div className="flex gap-2">
          <button className="btn btn-ghost flex items-center gap-1.5">
            <ThumbsUp className="w-4 h-4" /> Yes
          </button>
          <button className="btn btn-ghost flex items-center gap-1.5">
            <ThumbsDown className="w-4 h-4" /> No
          </button>
        </div>
      </div>
    </div>
  );
}
